import {useQuery} from "@tanstack/react-query";

import {getDashboardOverviewQueryKey} from "../lib";
import {dashboardService} from "../services";
import type {DashboardOverviewFilters} from "../types";

/** Aggregate snapshot: treat as fresh for several minutes to limit API churn. */
const STALE_MS = 5 * 60 * 1000;
const GC_MS = 15 * 60 * 1000;

export default function useDashboardOverview(
  filters: DashboardOverviewFilters,
  options: {enabled?: boolean} = {},
) {
  const {enabled = true} = options;

  return useQuery({
    queryKey: getDashboardOverviewQueryKey(filters),
    queryFn: () => dashboardService.getOverview(filters),
    enabled,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    refetchOnWindowFocus: false,
  });
}
